import { useContext } from 'react';
import { ExperienceContext } from '../providers/ExperienceProvider';
function useExperience() {
    return useContext(ExperienceContext);
}
export default useExperience;
